import run from '../../utilities/run';
import render from '../../utilities/render';
import FxoReceivingHomePageLogic from './fxoReceivingHomePageLogic';

const targetSelector = "#fxo-search-retailer-name";

run(targetSelector, (outerEl)=>{
 attachHtml(outerEl);
});

function attachHtml(outerEl){
  const fxoReceivingHomePageLogic = new FxoReceivingHomePageLogic(outerEl);
  fxoReceivingHomePageLogic.init();
};



// WEBPACK FOOTER //
// ./src/pages/fxoReceivingScreen/fxoReceivingHomePage.js